import Platform from "platform/Platform";
import {Http} from "platform/network/http/Http";
import {Logger} from "platform/logger/Logger";
import {LanguageUtil} from "platform/util/LanguageUtil";
import {Configuration, LocaleConfig} from "core/configuration/Configuration";

export class Locale {

    private static readonly _logger: Logger = Logger.Of("Locale");
    private static _config: LocaleConfig;

    private constructor() {
    }

    public static config(): LocaleConfig {
        return this._config;
    }

    public static async load(): Promise<void> {
        this._config = Platform.config<Configuration>().locale;
        let langCode: string;
        if (navigator && navigator.language) {
            langCode = navigator.language;
        } else {
            langCode = LanguageUtil.languageCode();
        }
        Http.getJson("resources/locales/" + langCode + ".json").then((data: LocaleConfig) => {
            this._config = data;
        }).catch((e) => {
            this._logger.debug("Failed load locale for language: " + langCode);
        });
    }
}
